import {apiClient} from "@/api/setupApi"

const BASE_API = "v1/motivation/miopia"

export default {
  getBalance(): Promise<any> {
    return apiClient.get(`${BASE_API}/balance/`)
  },
  activateCode(code: string): Promise<any> {
    return apiClient.post(`${BASE_API}/activate/`, {code})
  },
  getBonuses(params?: any): Promise<any> {
    return apiClient.get(`${BASE_API}/bonuses/`, {params})
  },
  assembleBonus(letters: string[]): Promise<any> {
    return apiClient.post(`${BASE_API}/bonuses/`, {letters})
  },
}
